/* eslint-disable */
import moment from 'moment';
import { apiRequest } from '@/calls/helpers';

const getAttraction = async (id) => {
  try {
    const request = await apiRequest('sapiti.php',{
      method: 'GET',
      endpoint: `/agenda/attractions/${id}`
    });

    if (request.error && request.error.code === 1501) {
      return {
        status: 'succes',
        data: 'stream'
      }
    }

    const { response } = request;

    const start = moment(response.firstevent_date).format('DD.MM.YYYY');
    const end = moment(response.lastevent_date).format('DD.MM.YYYY');

    const attraction = {
      id: response.id,
      title: response.label,
      description: response.description,
      headline: response.categories ? response.categories[0].label : null,
      picture: response.image_url,
      date: {
        start: response.firstevent_date,
        end: start === end ? null : response.lastevent_date
      },
      likes: 0,
      data: response
    };

    const req = await apiRequest('likes.php', { event: id });

    if (req && req.success && req.total) {
      attraction.likes = req.total;
    }

    return {
      success: request.proxy_success,
      error: request.proxy_error,
      data: attraction
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getProducts = async (id) => {
  try {
    const req = await apiRequest('sapiti.php',{
      method: 'GET',
      endpoint: '/agenda/events',
      data: {
        attractionid: id
      }
    });

    const events = req.response.map(e => e.id);
    const categories = [];

    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      const request = await apiRequest('sapiti.php',{
        method: 'GET',
        endpoint: '/shop/products/stocks',
        data: {
          eventid: event
        }
      });

      const { response } = request;
      const stock = response[0];

      if (stock && stock.capacity_free !== 0) {
        stock.categories = stock.categories.filter(cat => cat.capacity_free !== 0);

        stock.categories.map(cat => {
          const index = categories.filter(c => c.id === cat.id);

          if (index.length === 0) {
            cat.label = cat.label.charAt(0).toUpperCase() + cat.label.slice(1).toLowerCase();
            cat.prices = cat.prices.map(price => {
              price.label = price.label.charAt(0).toUpperCase() + price.label.slice(1).toLowerCase();
              return price;
            });

            categories.push(cat);
          }
        });
      }
    }

    return {
      success: true,
      error: false,
      data: categories
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getFullAttraction = async (id) => {
  try {
    const attractionRequest = await getAttraction(id);
    const attraction = attractionRequest;

    if (attraction === 'stream') {
      const streamRequest = await getFullStream(id);

      return {
        success: true,
        data: streamRequest
      }
    }
    attraction.events = [];

    const req = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: '/agenda/events',
      data: {
        attractionid: id
      }
    });

    const events = req.response;
    moment.locale('FR');

    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      event.date = moment(event.starttime).format('[Le] DD MMMM YYYY à HH:mm');

      const request = await apiRequest('sapiti.php',{
        method: 'GET',
        endpoint: '/shop/products/stocks',
        data: {
          eventid: event.id
        }
      });

      const { response } = request;
      const stock = response[0];

      if (stock && stock.capacity_free !== 0) {
        stock.categories = stock.categories.filter(cat => cat.capacity_free !== 0).map(cat => {
          cat.label = cat.label.charAt(0).toUpperCase() + cat.label.slice(1).toLowerCase();
          cat.prices = cat.prices.map(price => {
            price.label = price.label.charAt(0).toUpperCase() + price.label.slice(1).toLowerCase();
            price.categoryid = cat.id;
            price.stockid = stock.id;
            price.eventid = event.id;
            price.value.amount /= 100;
            return price;
          });

          return cat;
        });

        // eslint-disable-next-line
        event.products = response[0];

        if (event.products.categories && event.products.categories.length > 0) {
          attraction.events.push(event);
        }
      }
    }

    return {
      success: true,
      error: false,
      data: attraction
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getStream = async (id) => {
  try {
    const request = await apiRequest('sapiti.php',{
      method: 'GET',
      endpoint: `/catalogue/streams/${id}`
    });

    const { response } = request;

    const start = moment(response.starttime).format('DD.MM.YYYY');
    const end = moment(response.endtime).format('DD.MM.YYYY');

    const stream = {
      id: response.id,
      stream: true,
      title: response.label,
      description: response.description,
      headline: 'Streaming',
      picture: response.attraction.image_url,
      date: {
        start: response.starttime,
        end: start === end ? null : response.endtime
      },
      likes: 0,
      data: response
    };

    const req = await apiRequest('likes.php', { event: id });

    if (req && req.success && req.total) {
      stream.likes = req.total;
    }

    return {
      success: request.proxy_success,
      error: request.proxy_error,
      data: stream
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getStreamProducts = async (id) => {
  try {
    const request = await apiRequest('sapiti.php',{
      method: 'GET',
      endpoint: '/shop/products/stocks',
      data: {
        streamid: id
      }
    });

    const { response } = request;
    const stock = response[0];
    const categories = [];

    if (stock && stock.capacity_free !== 0) {
      stock.categories = stock.categories.filter(cat => cat.capacity_free !== 0);

      stock.categories.map(cat => {
        const index = categories.filter(c => c.id === cat.id);

        if (index.length === 0) {
          cat.label = cat.label.charAt(0).toUpperCase() + cat.label.slice(1).toLowerCase();
          cat.prices = cat.prices.map(price => {
            price.label = price.label.charAt(0).toUpperCase() + price.label.slice(1).toLowerCase();
            return price;
          });

          categories.push(cat);
        }
      });
    }

    return {
      success: true,
      error: false,
      data: categories
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
}

const getFullStream = async (id) => {
  try {
    const streamRequest = await getStream(id);
    const stream = streamRequest;
    stream.events = [];

    const stocks = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: '/shop/products/stocks',
      data: {
        streamid: stream.id
      }
    });

    const { response } = stocks;
    const stock = response[0];

    moment.locale('FR');
    const event = {
      id: stream.id,
      date: moment(stream.date.start).format('[Le] DD MMMM YYYY à HH:mm'),
      starttime: stream.starttime,
      products: null
    };

    if (stock && stock.capacity_free !== 0) {
      stock.categories = stock.categories.filter(cat => cat.capacity_free !== 0).map(cat => {
        cat.label = cat.label.charAt(0).toUpperCase() + cat.label.slice(1).toLowerCase();
        cat.prices = cat.prices.map(price => {
          price.label = price.label.charAt(0).toUpperCase() + price.label.slice(1).toLowerCase();
          price.categoryid = cat.id;
          price.stockid = stock.id;
          price.eventid = event.id;
          price.value.amount /= 100;
          return price;
        });

        return cat;
      });

      event.products = stock;
      stream.events.push(event);
    }

    return {
      success: true,
      error: false,
      data: stream
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};


export {
  // eslint-disable-next-line
  getProducts,
  getAttraction,
  getFullAttraction,
  getStream,
  getStreamProducts
};
